import React, { useEffect } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import "./splashinfo.css";

const useStyles = makeStyles((theme) => ({
  mainCont: {
    margin: 0,
    color: "white",
    background: "linear-gradient(to bottom, #000000 0%, #0066cc 100%)",
    marginBottom: "30px",
    paddingTop: "10vh",
    paddingBottom: "10vh",
    minWidth: '104vw'
  },
  heading: {
    // display: 'felx',
    padding: "5vh 0 5vh 18vw",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      padding: "5vh 0 5vh 10vw",
    },
  },
}));

function SplashInfo(props) {
  const classes = useStyles();
  const { fName, lName, occupation, github, linkedIn, resume } = props;
  let i = 0;
  const mainHeadingText = `Hi... I'm ${fName} ${lName}!`;
  const speed = 100;
  function typeWritter() {
    if (i < mainHeadingText.length) {
      document.getElementById(
        "main-heading"
      ).innerHTML += mainHeadingText.charAt(i);
      i++;
      setTimeout(typeWritter, speed);
    }
  }
  useEffect(() => {
    typeWritter();
  });

  return (
    <div className={classes.mainCont}>
      <div className={classes.heading}>
        <Typography id="main-heading" variant="h2"></Typography>
        <Typography
          className="fade-in"
          style={{ paddingTop: "2vh" }}
          variant="h5"
        >
          I'm a {occupation}.
        </Typography>
        <div className="social-media-icons fade-in">
          <ul>
            <li>
              <a href={github} target="_blank" rel="noopener noreferrer">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span className="fa fa-github"></span>
              </a>
            </li>
            <li>
              <a href={linkedIn} target="_blank" rel="noopener noreferrer">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span className="fa fa-linkedin"></span>
              </a>
            </li>
            <li>
              <a href={resume} target="_blank" rel="noopener noreferrer">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span>
                  <AssignmentIndIcon />
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SplashInfo
